const INITIAL_AUTHORIZED_PATH = '/catalog';
const LOGIN_PAGE = '/login';
const LOGOUT_PAGE = '/logout';

export { INITIAL_AUTHORIZED_PATH, LOGIN_PAGE, LOGOUT_PAGE };
